/*
 * element-plusのMessage系componentをEve用style設定付きで呼び出すためのwrapper
 */
import type { NotificationParamsTyped } from 'element-plus'
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
import { CloseBold } from '@element-plus/icons-vue'
export function _ElMessage(options: { type: string; message: string }): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const op: any = {
    appendTo: '#app',
    customClass: 'mm-message',
    // duration: 0, // for dev
    ...options,
  }
  ElMessage(op)
}

export const _ElConfirm = (message: string, title: string, options: Record<string, unknown>) => {
  const op = {
    appendTo: '#app',
    customClass: 'mm-confirm',
    closeIcon: CloseBold,
    ...options,
  }
  return ElMessageBox.confirm(message, title, op)
}

export const _ElNotification = (
  type: 'success' | 'warning' | 'info' | 'error' = 'info',
  message: string,
  title: string,
  options?: Record<string, unknown>,
) => {
  const op: NotificationParamsTyped = {
    appendTo: '#app',
    customClass: 'mm-notification',
    type,
    position: 'bottom-right',
    showClose: false,
    duration: 0,
    message,
    title,
    ...options,
  }
  return ElNotification(op)
}
